import React from 'react'
import PropTypes from 'prop-types'
import { createStyles, makeStyles } from '@mui/styles'

import { Icon } from '../../icons'
import './style.scss'

const useStyles = makeStyles((theme) =>
  createStyles({
    main: {
      borderBottom: `1px solid ${theme.palette.primary.main}`
    }
  })
)

export const FormTitle = ({ title, icon, iconSize, style, className }) => {
  const styleClasses = useStyles()
  return (
    <div className={`FormTitle ${styleClasses.main} ${className}`} style={style}>
      {icon && <Icon className="icon" name={icon} size={iconSize ? iconSize : 20} />}
      <h3>{title}</h3>
    </div>
  )
}

FormTitle.displayName = 'FormTitle'

FormTitle.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  iconSize: PropTypes.number,
  style: PropTypes.object,
  className: PropTypes.string
}

FormTitle.defaultProps = {
  title: null,
  icon: null,
  iconSize: null,
  style: {},
  className: ''
}
